export enum WidgetType {
    chat = 'chat',
    fb = 'fb',
    cb = 'cb'
}